import React, { memo, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory } from 'react-router-dom';

import styles from './AiAnswerIndex.module.less';
import AiAnswer1 from './AiAnswer1';
import AiAnswer2 from './AiAnswer2';
import AiAnswer3 from './AiAnswer3';
import AiAnswer4 from './AiAnswer4';
import AiAnswerError from './AiAnswerError';
import AiAnswer1001 from './AiAnswer1001';
import AiAnswer1002 from './AiAnswer1002';

import { aigcReplyIsBusing, aigcShowMessage, aigcSaveContext } from '../../../../actions/aigc';
import { logging } from '../../../../actions/log';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectIsBusing = createSelector(
  state => state.aigc,
  aigc => aigc.isBusing,
);

export default memo(({ answerList, showOperate, h5IDAll, userText }) => {
  const dispatch = useDispatch();
  const [answerIndexShow, setAnswerIndexShow] = useState(false);
  const [answerIndex, setAnswerIndex] = useState(1);
  const isBusing = useSelector(selectIsBusing);

  useEffect(() => {
    if (answerList?.length > 1) {
      setAnswerIndexShow(true);
    }
  }, [answerList]);

  const handleAnswerIndex = info => {
    let param3 = {};
    let index = answerIndex;
    if (isBusing === 4 || isBusing === 5) {
      if (info === 1) {
        if (answerIndex > 1) {
          setAnswerIndex(answerIndex - 1);
          index -= 1;
        }
      } else {
        if (answerIndex < answerList?.length) {
          setAnswerIndex(answerIndex + 1);
          index += 1;
        }
      }
      try {
        param3 = JSON.parse(answerList[index - 1]?.bizInfo);
      } catch (e) {
        param3 = {};
      }
      dispatch(
        logging({
          category: 'R',
          action: 'Search_Aigc_Turn',
          label: '',
          param2: {
            search_word: userText,
          },
          param3: param3,
        }),
      );
      if (answerList[index - 1]) {
        dispatch(
          aigcSaveContext({
            context: answerList?.[index - 1]?.context,
            h5ID: answerList?.[index - 1]?.h5ID,
            h5IDAll,
          }),
        );
      }
    }
  };

  const handleTest = e => {
    let dataTag = e.target.getAttribute('handle-data');
    if (dataTag === 'writing') {
      dispatch(aigcShowMessage({ isShow: true, content: '小乐还在输入中，请等待输入完成后操作' }));
    }
  };

  // 开始打字的时候传入状态
  const startWriting = () => {
    dispatch(aigcReplyIsBusing({ isBusing: 3 }));
  };

  // 控制点击重新回答后切换到最新的那个答案
  const switchIndex = () => {
    if (answerIndex !== answerList?.length) {
      setAnswerIndex(answerList?.length + 1);
    } else {
      setAnswerIndex(answerIndex + 1);
    }
  };

  return (
    <div className={styles.ai_answer}>
      {answerIndexShow && (
        <div className={styles.select_index}>
          <div
            className={` ${
              isBusing === 4 || isBusing === 5 ? 'select_opt_bg' : 'select_opt_bg_disable'
            }`}
          >
            <i
              className={`iconfont icon-opt_back ${
                isBusing === 4 || isBusing === 5 ? 'select_opt' : 'select_opt_disable'
              } `}
              onClick={() => {
                handleAnswerIndex(1);
              }}
            />
          </div>

          <span className="select_num">{`${answerIndex}/${answerList?.length}`}</span>
          <div
            className={` ${
              isBusing === 4 || isBusing === 5 ? 'select_opt_bg' : 'select_opt_bg_disable'
            }`}
          >
            <i
              className={`iconfont icon-point_right ${
                isBusing === 4 || isBusing === 5 ? 'select_opt' : 'select_opt_disable'
              } `}
              onClick={() => {
                handleAnswerIndex(2);
              }}
            />
          </div>
        </div>
      )}
      <>
        {Object.keys(answerList[answerIndex - 1]).length !== 0 && (
          <div className={styles.ai_answer_info} onClick={handleTest}>
            <>
              {/*回答出错异常*/}
              {['-1', '0', '-2', '1010'].includes(answerList[answerIndex - 1]?.commandCode) && (
                <AiAnswerError
                  styles={styles}
                  answerIndexShow={answerIndexShow}
                  answerIndex={answerIndex}
                  answerItem={{ ...answerList[answerIndex - 1] }}
                  showOperate={showOperate}
                  h5IDAll={h5IDAll}
                />
              )}

              {answerList[answerIndex - 1]?.commandCode === '1' && (
                <AiAnswer1
                  styles={styles}
                  answerIndexShow={answerIndexShow}
                  answerIndex={answerIndex}
                  answerItem={{ ...answerList[answerIndex - 1] }}
                  h5IDAll={h5IDAll}
                  showOperate={showOperate}
                  start={startWriting}
                  userText={userText}
                  reAnswerShow={answerList?.length <= 3}
                  reAnswerback={switchIndex}
                />
              )}

              {answerList[answerIndex - 1]?.commandCode === '2' && (
                <AiAnswer2
                  styles={styles}
                  answerIndexShow={answerIndexShow}
                  answerIndex={answerIndex}
                  answerItem={{ ...answerList[answerIndex - 1] }}
                  h5IDAll={h5IDAll}
                  showOperate={showOperate}
                  reAnswerback={switchIndex}
                  start={startWriting}
                  userText={userText}
                  reAnswerShow={answerList?.length <= 3}
                />
              )}
              {answerList[answerIndex - 1]?.commandCode === '3' && (
                <AiAnswer3
                  styles={styles}
                  answerIndexShow={answerIndexShow}
                  answerIndex={answerIndex}
                  answerItem={{ ...answerList[answerIndex - 1] }}
                  h5IDAll={h5IDAll}
                  showOperate={showOperate}
                  start={startWriting}
                  userText={userText}
                  reAnswerShow={answerList?.length <= 3}
                  reAnswerback={switchIndex}
                />
              )}
              {answerList[answerIndex - 1]?.commandCode === '4' && (
                <AiAnswer4
                  styles={styles}
                  answerIndexShow={answerIndexShow}
                  answerIndex={answerIndex}
                  answerItem={{ ...answerList[answerIndex - 1] }}
                  h5IDAll={h5IDAll}
                  showOperate={showOperate}
                  start={startWriting}
                  userText={userText}
                  reAnswerShow={answerList?.length <= 3}
                  reAnswerback={switchIndex}
                />
              )}
              {answerList[answerIndex - 1]?.commandCode === '1001' && (
                <AiAnswer1001
                  styles={styles}
                  answerIndexShow={answerIndexShow}
                  answerIndex={answerIndex}
                  answerItem={{ ...answerList[answerIndex - 1] }}
                  h5IDAll={h5IDAll}
                  showOperate={showOperate}
                  start={startWriting}
                  userText={userText}
                />
              )}
              {answerList[answerIndex - 1]?.commandCode === '1002' && (
                <AiAnswer1002
                  styles={styles}
                  answerIndexShow={answerIndexShow}
                  answerIndex={answerIndex}
                  answerItem={{ ...answerList[answerIndex - 1] }}
                  h5IDAll={h5IDAll}
                  showOperate={showOperate}
                  start={startWriting}
                />
              )}
            </>
          </div>
        )}
      </>
    </div>
  );
});
